import RouteIcon from "@mui/icons-material/Route";
import React from "react";
import Polygon from "./Polygon";

class FreeHand extends Polygon {
	id = "Freehand";
	name = "Free Loop";
	icon = <RouteIcon/>;
	freehand = true;
	className = "FreeHand-forTour"
	shortcutKey = "4";
}

export default FreeHand;
